import {makeStateKey} from '@angular/platform-browser';

// DOMAIN
export const STATE_LIST_MODE = makeStateKey('listMode');


